import scrollToElement from 'scroll-to-element';

export default class ScrollToLink {

	constructor(element) {
		this.handleClick = this.handleClick.bind(this);
		this.element = element;
		this.adminBar = document.getElementById('wpadminbar');
		this.masthead = document.getElementById('masthead');
		this.disabledSelectors = [
			'#save-the-date-modal',
			'#mailchimp-form-modal',
			'#cta-modal',
		];
	}

	init() {
		this.element.addEventListener('click', this.handleClick);
	}

	destroy() {
		this.element.removeEventListener('click', this.handleClick);
	}

	getOffset() {
		const adminBarHeight = (this.adminBar instanceof HTMLElement) ? this.adminBar.clientHeight : 0;
		const mastheadHeight = (this.masthead instanceof HTMLElement) ? this.masthead.clientHeight : 0;
		return ((adminBarHeight + mastheadHeight) * -1);
	}

	handleClick(e) {
		const { currentTarget } = e;
		let selector = currentTarget.getAttribute('href');
		if (! this.disabledSelectors.includes(selector)) {
			e.preventDefault();
			selector = (selector === '#') ? '#top' : selector;
			scrollToElement(selector, {
				offset: this.getOffset(),
				ease: 'in-out-quad',
			});
		}
	}
}
